module.exports = __webpack_public_path__ + "img/10.a0c83af5.jpeg";